import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {environment} from "../../environments/environment";
import {SUPPORTED_LANGUAGES} from "../tools/languages";
import {NavigationRoute} from "../tools/navigation/navigation-route";
import {LanguageProvider} from "./language-provider";

const REPORT_LANGUAGE_ROUTES = [
  NavigationRoute.ANALYSIS_ECG,
  NavigationRoute.ANALYSIS_BLOOD_PRESSURE,
  NavigationRoute.ANALYSIS_SLEEP
];

@Injectable()
export class UserLanguageProvider extends LanguageProvider {

  private reportLanguage?: string;

  constructor(private readonly router: Router) {
    super();
  }

  setReportLanguage(reportLanguage: string): void {
    this.reportLanguage = reportLanguage;
  }

  getLanguage(overrideReportLanguage: boolean = false): string {
    if (this.reportLanguage !== undefined && overrideReportLanguage === false && this.isOnReportLanguageRoute()) {
      return getSupportedLanguageOrDefault(this.reportLanguage);
    }

    return getSupportedLanguageOrDefault(environment.language);
  }

  private isOnReportLanguageRoute(): boolean {
    return REPORT_LANGUAGE_ROUTES.some(route => this.router.url.startsWith(`/${route}`));
  }
}

export function getSupportedLanguageOrDefault(language: string): string {
  if (SUPPORTED_LANGUAGES.some(supported => supported.code.toLowerCase() === language.toLowerCase())) {
    return language.toLowerCase();
  }

  return environment.eforms ? "en-gb" : "fi-fi";
}
